import { Navigate, useLocation } from "react-router";
import { ErrorBoundary } from "react-error-boundary";
import PageError from "@/pages/sys/error/PageError";

type Props = {
  readonly children: React.ReactNode;
};

export default function ProtectedRoute({ children }: Readonly<Props>) {
  const location = useLocation();

  // Safely get and parse userStore
  const getUserEmail = () => {
    try {
      const userStore = localStorage.getItem("userStore");
      if (!userStore) return null;

      const parsed = JSON.parse(userStore);
      return parsed?.state?.userInfo?.email || null;
    } catch (error) {
      console.error("Error parsing userStore:", error);
      return null;
    }
  };

  const email = getUserEmail();

  if (!email) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }

  return <ErrorBoundary FallbackComponent={PageError}>{children}</ErrorBoundary>;
}